<template>
  <div class="component-spedy">
    <div class="breadcrumbs d-flex align-items-center font-weight-bold mb-9">
      <router-link :to="{ name: 'home' }" class="text-secondary"
        >Início</router-link
      >
      <i class="icon-angle-right text-secondary mx-3"></i>
      <router-link :to="{ name: 'tools' }" class="text-secondary">
        Ferramentas
      </router-link>
      <i class="icon-angle-right text-secondary mx-3"></i>
      <router-link :to="{ name: 'tools-invoices' }" class="text-secondary">
        Notas fiscais
      </router-link>
      <i class="icon-angle-right text-secondary mx-3"></i>
      Spedy
    </div>

    <h6 class="d-none d-lg-block">Spedy</h6>
    <div class="row align-items-center mb-5 pt-6">
      <div class="col-lg-3 mb-3">
        <div class="d-flex align-items-center">
          <div class="mr-5">Integrações</div>
          <button
            class="btn btn-sm btn-outline-primary btn-square-sm p-5"
            @click="dispatch"
          >
            <i class="icon-refresh-ccw" />
          </button>
        </div>
      </div>
      <div class="col-lg-9">
        <div class="d-flex algn-items-center justify-content-end">
          <search-filter
            class="mr-3 flex-fill"
            placeholder="Pesquisar integração"
            :showFilters="false"
            :showResultsDropdown="false"
            @search="searching"
          />
          <button
            type="button"
            class="btn btn-primary px-5 px-lg-6"
            @click="modal = true"
          >
            <span class="d-none d-lg-inline">
              Adicionar
            </span>
            <i class="icon-plus d-lg-none lead"></i>
          </button>
        </div>
      </div>
    </div>
    <div v-if="loading" class="text-center">
      <b-spinner variant="primary" />
    </div>
    <div v-else>
      <div
        v-if="!integrationList.length"
        class="container centralize-row text-center pt-5"
      >
        <div class="row justify-content-center">
          <div class="col-lg-5">
            <img
              class="d-block my-9 mx-auto"
              src="@/assets/images/home/welcome.svg"
            />
            <h5>Você ainda não adicionou nenhuma integração</h5>
            <div class="text-secondary mb-5">
              Clique no botão acima para cadastrar
            </div>
          </div>
        </div>
      </div>
      <!-- Desktop area -->
      <div v-else>
        <data-table
          class="d-none d-lg-block pt-3"
          :columns="columns"
          :data="integrationList"
          columnsFr="1fr 1fr 0.8fr 0.4fr 0.3fr"
        >
          <template #default="{ item }">
            <small class="d-flex align-items-center">
              {{ item.product_name }}
            </small>
            <small class="d-flex align-items-center">
              {{ item.description | formatLongText }}
            </small>
            <small class="d-flex align-items-center mr-3">
              {{ item.token | formatLongText }}
            </small>
            <small class="d-flex align-items-center">
              <strong :class="item.status ? 'text-success' : 'text-danger'">{{
                item.status ? "Ativo" : "Inativo"
              }}</strong>
            </small>
            <div class="d-flex align-items-center justify-content-end">
              <actions-dropdown
                :left="false"
                :right="true"
                :actions="getActions(item)"
                @change-status="changeStatus(item)"
                @delete="submitDelete(item)"
                @edit="edit(item)"
              />
            </div>
          </template>
        </data-table>
        <!-- Desktop area -->
        <!-- Mobile area -->
        <data-table
          class="d-lg-none"
          :columns="columns.slice(0, 2).map(d => '')"
          :data="integrationList"
          :firstColumnFr="2"
          :lastColumnFr="0.5"
        >
          <template #default="{ item }">
            <div class="d-flex flex-column text-left pl-3 py-5">
              <small class="d-flex align-items-center">
                <strong class="mr-3">Produto: </strong>
                {{ item.product_name }}
              </small>
              <small class="d-flex align-items-center">
                <strong class="mr-3">Descrição: </strong>
                {{ item.description | formatLongText }}
              </small>
              <small class="d-flex align-items-center">
                <strong class="mr-3">Token: </strong>
                {{ item.token | formatLongText }}
              </small>
              <small class="d-flex align-items-center">
                <strong class="mr-3">Status: </strong>
                <strong :class="item.status ? 'text-success' : 'text-danger'">{{
                  item.status ? "Ativo" : "Inativo"
                }}</strong>
              </small>
            </div>
            <div class="d-flex justify-content-end">
              <actions-dropdown
                :left="false"
                :right="true"
                :actions="getActions(item)"
                @change-status="changeStatus(item)"
                @edit="edit(item)"
                @delete="submitDelete(item)"
              />
            </div>
          </template>
        </data-table>
      </div>
      <!-- Mobile area -->
      <div v-if="integrationList.length" class="d-flex justify-content-center">
        <paginator :pagination="pagination" @on-update="dispatch" />
      </div>
    </div>
    <spedy-modal
      v-model="modal"
      :integrationToEdit="integrationToEdit"
      @clear-edit="integrationToEdit = null"
      @update-list="dispatch"
    />
  </div>
</template>
<script>
import SpedyModal from "@/components/tools/modals/Spedy.vue";
import IntegrationsMixin from "@/mixins/integration.js";
import { mapState } from "vuex";
export default {
  mixins: [IntegrationsMixin],
  components: {
    SpedyModal
  },
  data() {
    return {
      loading: false,
      integrationToEdit: null,
      modal: false,
      integration: "spedy",
      search: "",
      columns: ["Produto", "Descrição", "Token", "Status", ""]
    };
  },
  mounted() {
    this.$store.commit("integration/setIntegration", this.integration);
    this.dispatch();
  },
  computed: {
    ...mapState("integration", ["integrationList", "pagination"]),
    ...mapState("product", ["products"])
  },
  methods: {
    formatLongText(txt) {
      if (txt) {
        return txt.length > 15 ? `${txt.slice(0, 15)}...` : `${txt}`;
      }
      return "-";
    },
    dispatch() {
      let params = {};

      if (this.search) {
        params = { search: this.search };
      }

      this.loading = true;
      this.$store
        .dispatch("integration/getIntegration", params)
        .catch(error => {
          this.$message.error("Não foi possível carregar as contas integradas");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    searching(v) {
      this.search = v;
      this.dispatch();
    },
    getActions(item) {
      return [
        {
          text: item.status ? "Desativar" : "Ativar",
          class: item.status ? "text-danger" : "text-success",
          icon: "icon-power",
          confirmation: {
            enable: false,
            text: ""
          },
          event: "change-status"
        },
        {
          text: "Editar",
          class: "",
          icon: "fa-solid fa-pen",
          confirmation: {
            enable: false,
            text: ""
          },
          event: "edit"
        },
        {
          text: "Excluir integração",
          class: "text-danger",
          icon: "icon-trash",
          confirmation: {
            enable: true,
            text: "Deseja mesmo excluir esta integração?"
          },
          event: "delete"
        }
      ];
    },
    changeStatus(item) {
      let data = { ...item, status: !item.status };
      this.$store
        .dispatch("integration/putIntegration", data)
        .then(() => {
          this.$message.success(
            `Integração ${data.status ? "ativada" : "desativada"}`
          );
          this.dispatch();
        })
        .catch(() => {
          this.$message.error(
            "Não foi possível alterar o status da integração"
          );
        });
    }
  }
};
</script>
